/**
 * Created by mykurisu on 2017/6/8.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {Dialog} from "react-weui";
import { WKCommentDialog } from '../../components/wk'
import "../../styles/lecture/LectureClassPush.css";
import "../../styles/lecture/LectureForm.css";
import DeepFocusDialog from '../../components/details/DeepFocusDialog'

class LectureForm extends Component {

    constructor() {
        super();
        this.state = {
            showQcode: '',
            qCode: '',
            couponCode: '',
            chatContent: '',
            discountErrorText: '',
            couponCodeStyle: {
                title: '输入优惠码',
                buttons: [
                    {
                        type: 'default',
                        label: '取消',
                        onClick: this.handleCouponClose.bind(this)
                    },
                    {
                        type: 'primary',
                        label: '确定',
                        onClick: this.handleCouponSubmit.bind(this)
                    }
                ]
            },
            chatContentStyle: {
                title: '课程咨询',
                buttons: [
                    {
                        type: 'default',
                        label: '取消',
                        onClick: this.handleChatClose.bind(this)
                    },
                    {
                        type: 'primary',
                        label: '提交',
                        onClick: this.handleChatSubmit.bind(this)
                    }
                ]
            },
        };
        this.handleCouponValue = this.handleCouponValue.bind(this);
        this.handleCouponClose = this.handleCouponClose.bind(this);
        this.handleChatValue = this.handleChatValue.bind(this);
        this.handleChatClose = this.handleChatClose.bind(this);
        this.handleChatSubmit = this.handleChatSubmit.bind(this);
        this.handleCouponSubmit = this.handleCouponSubmit.bind(this);
    }

    handleCouponValue(event) {
        this.setState({
            couponCode: event.target.value
        })
    }

    handleCouponClose() {
        this.props.dispatch({
            type: 'LECTURE_HIDE_DISCOUNT_PANEL'
        });
        this.setState({
            couponCode: '',
            discountErrorText: '',
        })
    }

    handleCouponSubmit() {
        const {lectureId, lectureAccess, channelAccess, role} = this.props;
        const discount_code = this.state.couponCode;
        if (this.state.couponCode.trim() === '') {
            this.setState({discountErrorText: '请输入优惠码'});
        } else {
            axios.post(`/api/lecture/${lectureId}/discount/${discount_code}/check`).then(res => {
                if (res.data.code !== 0) {
                    this.setState({discountErrorText: res.data.msg});
                }

                if (res.data.code === 0) {
                    this.setState({discountErrorText: ''});
                    this.handleCouponClose();

                    let isAccessGranted = !lectureAccess.granted || (channelAccess && !channelAccess.granted);
                    if (isAccessGranted && !role.is_liveroom_vip) {
                        this.props.dispatch({
                            type: 'LECTURE_SET_DISCOUNT',
                            payload: res.data.data.discount
                        });
                        this.props.dispatch({
                            type: 'LECTURE_SHOW_DISCOUNT_PAY_PANEL'
                        });
                    }
                }
            })
        }
    }

    handleChatValue(event) {
        this.setState({chatContent: event.target.value})
    }

    handleChatClose() {
        this.props.dispatch({
            type: 'LECTURE_HIDE_CHAT'
        });
        this.setState({chatContent: ''})
    }

    handleChatSubmit() {
        const {lectureId,channelId} = this.props;
        if (this.state.chatContent === '') {
            this.props.dispatch({
                type: 'LECTURE_HIDE_CHAT'
            });
            this.context.page.showAlert('未输入内容');
        } else if(lectureId !== undefined) {
            let data = new FormData();
            data.append('type', 'lecture');
            data.append('target_id', lectureId);
            data.append('content', this.state.chatContent);
            axios.post(`/api/messages/consult/${lectureId}`, data).then(res => {
                if (res.data.code === 0) {
                    if(res.data.data.is_subscribed) {
                        this.context.page.showToast('提交成功');
                        this.handleChatClose()
                    }else{
                        this.handleChatClose()
                        this.props.dispatch({
                            type: 'DEEP_FOCUS_DIALOG_SHOW'
                        });
                        this.setState({qCode:res.data.data.qrcode_content})
                        this.setState({showQcode: true})
                    } 
                } else {
                    return window._wk_toast.show(res.data.msg, '', 2000) 
                }
            });
        } else {
            let data = new FormData();
            data.append('type', 'channel');
            data.append('target_id', channelId);
            data.append('content', this.state.chatContent);
            axios.post(`/api/messages/consult/${channelId}`, data).then(res => {
                if (res.data.code === 0) {
                    if(res.data.data.is_subscribed) {
                        this.context.page.showToast('提交成功');
                        this.handleChatClose()
                    }else{
                        this.handleChatClose()
                        this.props.dispatch({
                            type: 'DEEP_FOCUS_DIALOG_SHOW'
                        });
                        this.setState({qCode:res.data.data.qrcode_content})
                        this.setState({showQcode: true})
                    } 
                } else {
                    return window._wk_toast.show(res.data.msg, '', 2000) 
                }
            });
        }
    }

    render() {
        const {showChat, showCoupon,wechat} = this.props;
        const {discountErrorText,showQcode} = this.state;
        return (
            <div className="lecture-classpush-dialog__container lecture-from__container">
                {showCoupon &&
                <div className="lecture-from-area_input">
                    <WKCommentDialog title={this.state.couponCodeStyle.title} buttons={this.state.couponCodeStyle.buttons}
                            show={showCoupon}>
                        <input type="number" value={this.state.couponCode} pattern="[0-9]*"
                               onChange={this.handleCouponValue}/>
                        <p>{discountErrorText}</p>
                    </WKCommentDialog>
                </div>
                }
                {showChat &&
                <div className="lecture-from-area_textarea">
                    <WKCommentDialog title={this.state.chatContentStyle.title} buttons={this.state.chatContentStyle.buttons}
                            show={showChat}>
                        <textarea placeholder="在此处输入想咨询的问题，我们会尽快答复你" value={this.state.chatContent}
                                  onChange={this.handleChatValue}>
                        </textarea>
                    </WKCommentDialog>
                </div>
                }
                {showQcode && 
                    <DeepFocusDialog type="lecture_consult" qcode={this.state.qCode}/>
                }
            </div>
        )
    }
}

LectureForm.contextTypes = {
    page: React.PropTypes.object,
};

export default connect((state) => ({
    showChat: state.lecture.showChat,
    showCoupon: state.lecture.showCoupon,
    lectureAccess: state.lecture.lecture_access,
    channelAccess: state.lecture.channel_access,
    role: state.lecture.role,
    wechat: state.wechat,
}))(LectureForm)



// WEBPACK FOOTER //
// ./src/components/lecture/LectureForm.js